import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SnackarInterceptor } from './interceptor/snackbar.interceptor';
import { AuthenticationInterceptor } from './interceptor/authentication.interceptor';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SnackarInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
